function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  stroke: "currentcolor",
  fill: "currentcolor",
  strokeWidth: "0",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h6v6H0zM0 9h6v6H0zM6 18H0v6h6zM9 0h6v6H9zM15 9H9v6h6zM9 18h6v6H9zM24 0h-6v6h6zM18 9h6v6h-6zM24 18h-6v6h6z"
}))));